import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const alertVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("relative w-full rounded-[12px] border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[16px_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current has-[button]:pr-12", {
    variants: {
        variant: {
            default: "bg-grayscale-darker text-foreground [&>[data-slot=alert-description]]:text-secondary-foreground",
            primary: "text-brand-primary bg-brand-primary/10 border-brand-primary/20 [&>svg]:text-current [&>[data-slot=alert-description]]:text-brand-primary/90",
            destructive: "text-alert-primary bg-alert-background/40 border-alert-background [&>svg]:text-current [&>[data-slot=alert-description]]:text-alert-primary/90",
            warning: "text-amber-500 bg-amber-500/10 border-amber-500/20 [&>svg]:text-current [&>[data-slot=alert-description]]:text-amber-500/90"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function generateAlertId(title, customKey) {
    if (customKey) return customKey;
    return `alert-${title.toLowerCase().replace(/[^a-z0-9]/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "")}`;
}
function isAlertDismissed(alertId, duration, storageType = "localStorage") {
    if ("undefined" == typeof window) return false;
    const storage = "sessionStorage" === storageType ? sessionStorage : localStorage;
    const stored = storage.getItem(alertId);
    if (!stored) return false;
    if ("forever" === duration || void 0 === duration) return true;
    const dismissedAt = parseInt(stored, 10);
    const expiryTime = dismissedAt + 24 * duration * 3600000;
    if (Date.now() > expiryTime) {
        storage.removeItem(alertId);
        return false;
    }
    return true;
}
function dismissAlert(alertId, storageType = "localStorage") {
    if ("undefined" == typeof window) return;
    const storage = "sessionStorage" === storageType ? sessionStorage : localStorage;
    storage.setItem(alertId, Date.now().toString());
}
function Alert({ className, variant, icon, iconClassName, dismissible, ...props }) {
    const titleElement = __WEBPACK_EXTERNAL_MODULE_react__.Children.toArray(props.children).find((child)=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.isValidElement(child) && "alert-title" === child.props["data-slot"]);
    const title = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.isValidElement(titleElement) && "string" == typeof titleElement.props.children ? titleElement.props.children : "unnamed-alert";
    const alertId = generateAlertId(title, dismissible?.storageKey);
    const storageType = dismissible?.storage || "localStorage";
    const [isDismissed, setIsDismissed] = __WEBPACK_EXTERNAL_MODULE_react__.useState(()=>dismissible ? isAlertDismissed(alertId, dismissible.duration, storageType) : false);
    const handleDismiss = ()=>{
        if (dismissible) {
            dismissAlert(alertId, storageType);
            setIsDismissed(true);
            dismissible.onDismiss?.();
        }
    };
    if (isDismissed) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        "data-slot": "alert",
        role: "alert",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(alertVariants({
            variant
        }), className),
        ...props,
        children: [
            icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                type: icon,
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("opacity-50", iconClassName)
            }) : null,
            props.children,
            dismissible && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("button", {
                onClick: handleDismiss,
                className: "absolute top-3 right-3 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:outline-hidden disabled:pointer-events-none cursor-pointer",
                "aria-label": "Dismiss alert",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.XIcon, {
                        className: "size-4"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        className: "sr-only",
                        children: "Close"
                    })
                ]
            })
        ]
    });
}
function AlertTitle({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        "data-slot": "alert-title",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight", className),
        ...props
    });
}
function AlertDescription({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        "data-slot": "alert-description",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed", className),
        ...props
    });
}
export { Alert, AlertDescription, AlertTitle };
